<template>
  <div>
    <el-select
      clearable
      class="widthStyle"
      :value="value"
      filterable
      @change="change"
      :disabled="disabled"
      :placeholder="placeholder"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/dataBase';
  export default {
    name: 'dictSelect',
    data() {
      return {
        options: [],
      };
    },
    computed: {
      ...mapState({
        dictList: (state) => state.dict.dictList,
        dictListMap: (state) => state.dict.dictListMap,
      }),
    },
    props: {
      value: {
        // 必须要使用value ==父组件v-model值
        default: '',
      },
      type: {
        type: String,
        default: () => '',
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
      placeholder: {
        type: String,
        default: () => '',
      },
      valueType: {
        type: String,
        default: () => 'string',
      },
    },
    mounted() {
      let dictInfo = this.dictListMap[this.type];
      if (!dictInfo || dictInfo == undefined) {
        if (['often_currency', 'all_currency'].indexOf(this.type) != -1) {
          //币种
          this.$baseRequest.getCurrency({ isEnabled: 1 }).then((res) => {
            if (res[0]) {
              let list = res.map((it) => {
                it['value'] = it.currencyCode;
                it['label'] = it.currencyName;
                return it;
              });
              let obj = [
                {
                  dictType: 'all_currency',
                  dictName: '全部币种',
                  dictList: list,
                },
              ];
              this.$store.dispatch('dict/updateDictList', obj);

              let list_often = list.filter((item) => item.commonFlag == 'Y');
              let obj_often = [
                {
                  dictType: 'often_currency',
                  dictName: '常用币种',
                  dictList: list_often,
                },
              ];
              this.$store.dispatch('dict/updateDictList', obj_often);
              this.type == 'all_currency' ? (this.options = list) : (this.options = list_often);
            }
          });
        } else {
          this.$axios.post(API.DIC_CREDIT_API, { dictType: this.type }).then((res) => {
            if (res.data.code === 0) {
              this.options = res.data.data;
              let obj = {
                dictType: this.type,
                dictList: res.data.data,
              };
              this.$store.dispatch('dict/updateDictList', obj);
              this.$store.dispatch('dict/updateDictList', obj);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      } else {
        this.options = dictInfo;
      }
    },
    methods: {
      change(value) {
        this.$emit('input', value);
        if (this.valueType == 'object') {
          this.$emit(
            'change',
            this.options.find((it) => it.value == value)
          );
        } else {
          this.$emit('change', value, this.options.find((it) => it.value == value).label);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widthStyle {
    width: 100%;
  }
</style>
